import { isEqual } from 'lodash'
import { Product } from '../../../hooks/useProduct'
import { CreateLocalizationPayload } from '../api/create'
import { UpdateLocalizationPayload } from '../api/update'
import { CreateLocalizationFormType, EditLocalizationFormType } from './types'

export const formatCreatePayload = (
  values: CreateLocalizationFormType,
  product: Product,
  catalogProductId?: string
): CreateLocalizationPayload => {
  const [country, subdivision] = values.state_selector.split('-')

  const payload: CreateLocalizationPayload = {
    catalog_product_id: product.uuid,
    country: country,
    subdivision: subdivision,
  }

  if (catalogProductId) {
    payload.catalog_product_id = catalogProductId
  }

  if (values.name !== product.name) {
    payload.name = values.name
  }

  if (values.description !== product.description) {
    payload.description = values.description
  }

  if (values.category_label !== product.kind_subtype) {
    payload.category_label = values.category_label
  }

  if (values.lineage !== product.category) {
    payload.lineage = values.lineage
  }

  if (!isEqual(values.image_urls, product.image_urls)) {
    payload.images = values.image_urls
    payload.image_urls = values.image_urls
  }

  return payload
}

export const formatUpdatePayload = (
  values: EditLocalizationFormType,
  product: Product
): UpdateLocalizationPayload => {
  const payload: UpdateLocalizationPayload = {
    name: values.name,
    description: values.description,
    category_label: values.category_label,
    lineage: values.lineage,
    images: values.image_urls,
    image_urls: values.image_urls,
  }

  if (values.name === product.name) {
    payload.name = null
  }

  if (values.description === product.description) {
    payload.description = null
  }

  if (values.category_label === product.kind_subtype) {
    payload.category_label = null
  }

  if (values.lineage === product.category) {
    payload.lineage = null
  }

  if (isEqual(values.image_urls, product.image_urls)) {
    payload.images = null
    payload.image_urls = null
  }

  return payload
}
